// EmpatiQ Analyze (the therapy workspace) was archived on 2026-09-26 — see
// src/_archive/analyze-2026-09-26/README.md. Its URLs lead to where that work
// lives now: recorded conversations under Recordings, files in the Library,
// and the product's marketing and front-door pages to the generic ones.
//
// A recording itself (/clients/:id/sessions/:id) is NOT archived: it is the
// Recordings flow of the general workspace and keeps its URL.

const EXACT: Record<string, string> = {
  "/clients": "/sessions",
  "/cessions": "/sessions",
  "/schedule": "/sessions",
  "/notes": "/sessions",
  "/files": "/dashboard/tools",
  "/notes/login": "/login",
  "/notes/signup": "/signup",
  "/products/therapy-workspace": "/",
};

/** Where a retired Analyze URL now leads, or null for a live URL. */
export function archivedAnalyzeTarget(path: string): string | null {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  if (EXACT[pathname]) return EXACT[pathname];
  if (/^\/clients\/[^/]+\/sessions\/[^/]+/.test(pathname)) return null;
  if (/^\/clients\/[^/]+$/.test(pathname)) return "/sessions";
  if (/^\/files\/[^/]+$/.test(pathname)) return "/dashboard/tools";
  if (/^\/notes\/demo(\/.*)?$/.test(pathname)) return "/";
  if (/^\/products\/notes\/[^/]+$/.test(pathname)) return "/";
  return null;
}
